(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ff-room-index"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ff-room-index')) {
    class FFRoomIndex extends HTMLElement {
      connectedCallback() {
        this.roomAttached = true;
        if (this.initializeRooms() || this.roomInitPending) return;
        this.roomInitPending = true;
        this.roomReadyHandler = () => {
          if (this.roomAttached) this.initializeRooms();
          this.clearRoomInitialization();
        };
        document.addEventListener('DOMContentLoaded', this.roomReadyHandler, { once: true });
        this.roomInitFrame = requestAnimationFrame(() => {
          this.roomInitFrame = null;
          if (this.roomAttached && this.initializeRooms()) this.clearRoomInitialization();
          else if (document.readyState !== 'loading') this.clearRoomInitialization();
        });
      }

      initializeRooms() {
        if (this.roomBindings) return true;
        this.stage = this.querySelector('[data-room-stage]');
        this.stageMedia = this.querySelector('[data-room-stage-media]');
        this.stageTitle = this.querySelector('[data-room-stage-title]');
        this.stageLink = this.querySelector('[data-room-stage-link]');
        this.status = this.querySelector('[data-room-status]');
        this.rooms = Array.from(this.querySelectorAll('[data-room-choice]')).map((element) => ({
          element,
          id: element.getAttribute('data-room-id'),
          title: element.getAttribute('data-room-title'),
          link: element.querySelector('[data-room-link]'),
          button: element.querySelector('[data-room-preview]'),
          template: element.querySelector('[data-room-template]'),
        })).filter((room) => room.id && room.link?.getAttribute('href')?.trim() && room.button && room.template?.content?.firstElementChild);
        if (!this.rooms.length || !this.stage || !this.stageMedia || !this.stageTitle || !this.stageLink || !this.status) return false;

        this.roomBindings = [];
        this.activeRoomId = this.getAttribute('data-active-room') || this.getAttribute('data-initial-room');
        const initialRoom = this.rooms.find((room) => room.id === this.activeRoomId) || this.rooms[0];
        this.rooms.forEach((room) => {
          this.bindRoomEvent(room.button, 'click', () => this.previewRoom(room, true));
          this.bindRoomEvent(room.link, 'mouseenter', () => this.previewRoom(room, false));
          this.bindRoomEvent(room.link, 'focus', () => this.previewRoom(room, false));
          room.button.hidden = false;
        });
        this.bindRoomEvent(document, 'shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const room = this.rooms.find((candidate) => candidate.id === event.detail?.blockId);
          if (room) this.previewRoom(room, false);
        });
        this.previewRoom(initialRoom, false);
        this.setAttribute('data-enhanced', 'true');
        return true;
      }

      disconnectedCallback() {
        this.roomAttached = false;
        this.clearRoomInitialization();
        this.cancelRoomPreview();
        if (!this.roomBindings) return;
        this.roomBindings.forEach(({ target, type, handler }) => target.removeEventListener(type, handler));
        this.rooms.forEach((room) => { room.button.hidden = true; });
        this.roomBindings = null;
        this.removeAttribute('data-enhanced');
      }

      clearRoomInitialization() {
        if (this.roomInitFrame) cancelAnimationFrame(this.roomInitFrame);
        if (this.roomReadyHandler) document.removeEventListener('DOMContentLoaded', this.roomReadyHandler);
        this.roomInitFrame = null;
        this.roomReadyHandler = null;
        this.roomInitPending = false;
      }

      bindRoomEvent(target, type, handler) {
        target.addEventListener(type, handler);
        this.roomBindings.push({ target, type, handler });
      }

      previewRoom(room, announce) {
        if (room.id === this.activeRoomId) {
          this.cancelRoomPreview();
          this.setActiveRoom(room);
          if (announce) this.finishExplicitPreview(room);
          else this.setRoomStatus('', 'idle');
          return Promise.resolve(true);
        }

        if (this.pendingRoomPreview?.room.id === room.id) {
          if (announce) {
            this.pendingRoomPreview.announce = true;
            this.setRoomStatus(this.getAttribute('data-loading-label'), 'loading');
          }
          return this.pendingRoomPreview.promise;
        }

        this.cancelRoomPreview();
        const request = { room, announce };
        this.pendingRoomPreview = request;
        room.button.setAttribute('aria-busy', 'true');
        this.stageMedia.setAttribute('aria-busy', 'true');
        if (announce) this.setRoomStatus(this.getAttribute('data-loading-label'), 'loading');
        else this.setRoomStatus('', 'idle');

        const cancelled = new Promise((resolve, reject) => {
          request.cancel = () => reject(new Error('Room preview cancelled'));
        });
        request.timeout = setTimeout(() => request.cancel(), 10000);
        const prepared = Promise.resolve().then(() => {
          if (!this.roomAttached || this.pendingRoomPreview !== request) throw new Error('Room preview cancelled');
          request.fragment = document.importNode(room.template.content, true);
          const image = request.fragment.querySelector('img');
          if (!image) return;
          image.loading = 'eager';
          if (typeof image.decode === 'function') {
            return image.decode().then(() => {
              if (!image.naturalWidth) throw new Error('Room preview unavailable');
            });
          }
          if (image.complete) {
            if (!image.naturalWidth) throw new Error('Room preview unavailable');
            return;
          }
          return new Promise((resolve, reject) => {
            const loaded = () => image.naturalWidth ? resolve() : reject(new Error('Room preview unavailable'));
            const failed = () => reject(new Error('Room preview unavailable'));
            image.addEventListener('load', loaded, { once: true });
            image.addEventListener('error', failed, { once: true });
            request.cleanupImage = () => {
              image.removeEventListener('load', loaded);
              image.removeEventListener('error', failed);
            };
          });
        });

        request.promise = Promise.race([prepared, cancelled])
          .then(() => {
            if (!this.roomAttached || this.pendingRoomPreview !== request) return false;
            this.stageMedia.replaceChildren(request.fragment);
            this.stageTitle.textContent = room.title;
            this.stageLink.setAttribute('href', room.link.getAttribute('href'));
            this.setActiveRoom(room);
            if (request.announce) this.finishExplicitPreview(room);
            return true;
          })
          .catch(() => {
            if (this.roomAttached && this.pendingRoomPreview === request && request.announce) {
              this.setRoomStatus(this.getAttribute('data-error-label'), 'error');
            }
            return false;
          })
          .finally(() => {
            this.resetRoomPreview(request);
            if (this.pendingRoomPreview === request) this.pendingRoomPreview = null;
          });
        return request.promise;
      }

      setActiveRoom(room) {
        this.activeRoomId = room.id;
        this.setAttribute('data-active-room', room.id);
        this.rooms.forEach((candidate) => {
          const active = candidate.id === room.id;
          candidate.element.setAttribute('data-active', String(active));
          candidate.button.setAttribute('aria-pressed', String(active));
        });
      }

      finishExplicitPreview(room) {
        this.setRoomStatus(room.button.getAttribute('data-viewing-label'), 'success');
        if (window.matchMedia('(max-width: 749px)').matches) {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.stage.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
        }
      }

      setRoomStatus(message, state) {
        this.status.textContent = message || '';
        this.status.setAttribute('data-state', state);
        this.status.classList.toggle('visually-hidden', state !== 'loading' && state !== 'error');
      }

      cancelRoomPreview() {
        const request = this.pendingRoomPreview;
        if (!request) return;
        this.pendingRoomPreview = null;
        request.cancel();
        this.resetRoomPreview(request);
        this.setRoomStatus('', 'idle');
      }

      resetRoomPreview(request) {
        if (request.cleaned) return;
        request.cleaned = true;
        clearTimeout(request.timeout);
        request.cleanupImage?.();
        request.room.button.removeAttribute('aria-busy');
        if (!this.pendingRoomPreview || this.pendingRoomPreview === request) this.stageMedia.removeAttribute('aria-busy');
      }
    }
    customElements.define('ff-room-index', FFRoomIndex);
  }
  } catch(e) { console.error(e); }
})();

})();
